import { render, staticRenderFns } from "./index.vue?vue&type=template&id=637cffa6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=637cffa6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637cffa6')) {
      api.createRecord('637cffa6', component.options)
    } else {
      api.reload('637cffa6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=637cffa6", function () {
      api.rerender('637cffa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/coupon/exchangeCouponField/index.vue"
export default component.exports